import { FragmentRESTSerializer } from 'ember-data-model-fragments/serializer';

// TS-STANDIN(RESTSerializer): WarpDrive declares RESTSerializer as any, and
// ember-data-model-fragments types FragmentRESTSerializer against
// @ember-data/serializer, which this repo does not install. This type lists
// the methods that the serializers here call.
export interface RESTSerializerMethods {
  payloadKeyFromModelName(modelName: string): string;
  modelNameFromPayloadKey(key: string): string;
  normalize(
    modelClass: unknown,
    hash: Record<string, unknown>,
    prop?: string,
  ): unknown;
  serialize(
    snapshot: unknown,
    options?: { includeId?: boolean },
  ): Record<string, unknown>;
}

const RESTBase = FragmentRESTSerializer as unknown as new (
  ...args: unknown[]
) => RESTSerializerMethods;

export default class NamespacedSerializer extends RESTBase {
  // namespace is the model name prefix that the payload keys do not have.
  namespace = '';

  // rootKeys are payload keys that name a model with no namespace, for
  // example `person` in a `people` payload.
  rootKeys: readonly string[] = [];

  payloadKeyFromModelName(modelName: string): string {
    const key = super.payloadKeyFromModelName(modelName);
    const prefix = `${this.namespace}/`;
    return this.namespace && key.startsWith(prefix)
      ? key.slice(prefix.length)
      : key;
  }

  modelNameFromPayloadKey(key: string): string {
    if (!this.namespace || this.rootKeys.includes(key)) {
      return super.modelNameFromPayloadKey(key);
    }
    return super.modelNameFromPayloadKey(`${this.namespace}/${key}`);
  }
}
